import { Component, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { ExerciseStateService } from '@therapist/shared/services/state/exercise-state.service';
import { ExerciseTemplateDto } from '@therapist/shared/models/exercise/exercise-template.dto';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { Router } from '@angular/router';

@Component({
  selector: 'sana-tp-therapy-plan-add-exercise-confirmation-dialog',
  imports: [Button],
  templateUrl: './therapy-plan-add-exercise-confirmation-dialog.component.html',
  styleUrl: './therapy-plan-add-exercise-confirmation-dialog.component.scss'
})
export class TherapyPlanAddExerciseConfirmationDialogComponent {

  readonly #exerciseStateService = inject(ExerciseStateService);
  readonly #clientStateService = inject(TherapistClientStateService);
  readonly #router = inject(Router);

  selectedClient = this.#clientStateService.getSelectedClient();
  selectedExerciseList = this.#exerciseStateService.getSelectedExercises();

  removeExerciseFromPlan(exercise: ExerciseTemplateDto) {
    this.#exerciseStateService.removeSelectedExercise(exercise.id);
  }

  protected routeToTherapyPlanDetails(): void {
    this.#router.navigate([`/client/${this.selectedClient()!.id}/therapy-plan/add/data`]);
  }
}
